import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const BudgetVarianceTable = ({ items }) => {
  const { t } = useLanguage();

  return (
    <div className="bg-card rounded-xl border border-border shadow-sm overflow-hidden">
      <div className="px-6 py-4 border-b border-border">
        <h3 className="font-semibold text-foreground">{t('varianceAnalysis')}</h3>
        <p className="text-sm text-muted-foreground">{t('varianceAnalysisSubtitle')}</p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-muted/50">
            <tr>
              <th className="text-left px-6 py-3 font-medium text-muted-foreground">{t('category')}</th>
              <th className="text-right px-4 py-3 font-medium text-muted-foreground">{t('budget')}</th>
              <th className="text-right px-4 py-3 font-medium text-muted-foreground">{t('actual')}</th>
              <th className="text-right px-4 py-3 font-medium text-muted-foreground">{t('variance')}</th>
              <th className="text-right px-6 py-3 font-medium text-muted-foreground">{t('status')}</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {items?.map((item) => {
              const variance = item?.actual - item?.budget;
              const variancePct = Math.round((variance / item?.budget) * 100);
              const isOver = variance > 0;
              return (
                <tr key={item?.category} className="hover:bg-muted/30 transition-colors">
                  <td className="px-6 py-3 font-medium text-foreground">{item?.category}</td>
                  <td className="px-4 py-3 text-right text-muted-foreground">£{item?.budget?.toLocaleString()}</td>
                  <td className="px-4 py-3 text-right font-medium text-foreground">£{item?.actual?.toLocaleString()}</td>
                  <td className={`px-4 py-3 text-right font-semibold ${isOver ? 'text-red-600' : 'text-emerald-600'}`}>
                    {isOver ? '+' : ''}£{Math.abs(variance)?.toLocaleString()} ({isOver ? '+' : ''}{variancePct}%)
                  </td>
                  <td className="px-6 py-3 text-right">
                    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${
                      isOver ? 'bg-red-100 text-red-700' : 'bg-emerald-100 text-emerald-700'
                    }`}>
                      <Icon name={isOver ? 'TrendingUp' : 'TrendingDown'} size={11} />
                      {isOver ? t('overBudgetLabel') : t('underBudgetLabel')}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BudgetVarianceTable;
